module.exports = __webpack_public_path__ + "img/vo-way-1.82de8568.svg";